import { render } from "./Info_2.vue?vue&type=template&id=6ca130ac"
import script from "./Info_2.vue?vue&type=script&lang=js"
export * from "./Info_2.vue?vue&type=script&lang=js"

import exportComponent from "/home/milu/Projects/tesco-csapatnap/csapatnap.hu-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__